import { Navigate } from "react-router-dom";
import { useAuthContext } from "../context/authContextInstance";
import { toast } from "react-toastify";

/**
 * Componente para proteger rutas según roles
 * @param {string[]} rolesPermitidos - Array de roles que pueden acceder
 * @param {JSX.Element} children - Componente hijo a renderizar si tiene permiso
 */
function RoleGuard({ rolesPermitidos, children }) {
  const { usuario, isAuthenticated } = useAuthContext();

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/Login" replace />;
  }

  // Si no tiene el rol adecuado, redirigir al dashboard con mensaje
  if (!rolesPermitidos.includes(usuario?.rol)) {
    toast.error("No tienes permisos para acceder a esta página");
    return <Navigate to="/dashboard" replace />;
  }

  // Si tiene permiso, mostrar el componente
  return children;
}

export default RoleGuard;
